import { DocumentEditModalForm } from "./DocumentEditModalForm"


const DocumentEditModalFormWrapper = () => {
    return (<DocumentEditModalForm />)
}

export {DocumentEditModalFormWrapper}